import PosthogService from '~/services/posthog/PosthogService';
import { toCandidatePositionProperties, type IConfirmCandidatePositionContext } from './types';

export interface IConfirmCandidateCandidateViewedPayload
  extends IConfirmCandidatePositionContext {
  // Required here, unlike on the action events: the impression is fired from the
  // screen that owns the list, so the count and the current offer are always known.
  candidateCount: number;
  offerId: string;
  professionalId: string;
}

/**
 * Fires when an office views a candidate on the Confirm Candidate page.
 * Auto-fires for the first candidate on page load; fires on tab click for subsequent candidates.
 * Event: dental_portal:confirm_candidate:candidate_viewed
 */
export function fireConfirmCandidateCandidateViewed(
  payload: IConfirmCandidateCandidateViewedPayload,
): void {
  PosthogService.getInstance().track(
    'dental_portal:confirm_candidate:candidate_viewed',
    toCandidatePositionProperties(payload),
  );
}
